module.exports = __webpack_public_path__ + "img/mobile-menu.3e3e21a2.svg";